module.exports = __webpack_public_path__ + "img/feature-item-01.d16e7872.png";